import { MainContent } from "./MainContent";

export default function SimplifiedPostItemV3({ post, ...rest }) {
  return <MainContent post={post} {...rest} />;
}
